import { createAction } from '@reduxjs/toolkit';

export const setUserList = createAction('userList/SET', data => {
    return {
        payload: data,
    };
});
